import CoinsIcon from 'components/ReusableComponents/Icons/Coins'
import GiftIcon from 'components/ReusableComponents/Icons/Gift'
import UserIcon from 'components/ReusableComponents/Icons/User'
import CalendarComplete from 'features/CustomCampaigns/EditCampaign/CalendarComplete'
import moment from 'moment'
import { formatPrice } from 'utils/common'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './EditCampaign.module.scss'

const CustomCampaignEstimation = ({
  audienceSize,
  deliveryStartDate,
  deliveryFinishDate
}) => {
  const sentTextsPerDay = 1000
  const textCostPerDay = 0.03

  const guestsWillBeReached = deliveryFinishDate
    ? Math.min(
        moment(deliveryFinishDate).diff(deliveryStartDate, 'days') * sentTextsPerDay,
        audienceSize
      )
    : audienceSize

  const campaignDurationInDays = Math.floor(guestsWillBeReached / sentTextsPerDay)
  const campaignCost = guestsWillBeReached * textCostPerDay

  const estimatedEndDate = moment(deliveryStartDate).add(
    campaignDurationInDays + 1,
    'day'
  )

  return (
    <div className={styles.estimationHolder} id="text-blast-estimation">
      <div className={styles.estimatedEndDateHolder}>
        <CalendarComplete />
        <div className={styles.estimatedEndDateInner}>
          <p className={styles.estimatedEndDateLabel}> Estimated end date</p>
          <p className={styles.estimatedEndDateValue}>
            {estimatedEndDate.format('MMM D, YYYY')}{' '}
          </p>
        </div>
      </div>
      <div className={styles.estimationDetails}>
        <div className={styles.estimationDetailsRow}>
          <UserIcon width={20} />
          <p className={styles.estimationDetailText}>
            {formatNumberAsThousands(guestsWillBeReached)} guests will be reached
          </p>
        </div>
        <div className={styles.estimationDetailsRow}>
          <CoinsIcon width={20} style={{ position: 'relative', left: 1 }} />
          <p className={styles.estimationDetailText}>
            {formatPrice(campaignCost)} approx. ({formatPrice(textCostPerDay)} / text)
          </p>
        </div>
        <div className={styles.estimationDetailsRow}>
          <GiftIcon width={20} />
          <p className={styles.estimationDetailText}>
            Every month, first 500 messages are free of charge
          </p>
        </div>
      </div>
    </div>
  )
}

export default CustomCampaignEstimation
